import React, { Component } from "react";
import { Form, Input, Button, message } from "antd";
import { Link, withRouter } from "react-router-dom";
import "../../scss/auth.scss"
import { forgetPassword } from "../../network/auth.network";
import { connect } from "react-redux";
import { setCurrentUser } from "../../redux/user/user.action";
import localization from '../../Localization/Localization.json'
import logo from "../../assets/password.png" 
import authBG from "../../assets/auth.png" 
import { FaChevronRight } from "react-icons/fa";

// import TiSocialFacebookCircular from 'react-icons/lib/ti/social-facebook-circular';

class ForgetPassword extends Component {
  constructor() {
    super();
    this.state = {
      btnLoading: false,
    };
  }

  onFinish = (values) => {
    this.setState({btnLoading : true});
    // setTimeout(() => {
    //   this.setState({btnLoading : false})
    //   this.props.history.push("/phone-verification"); 
    // }, 1000)  
    let emailVal = values.email;
    forgetPassword(emailVal,
      (res)=>{
        this.setState({btnLoading : false});
       this.props.history.replace({pathname:"/phone-verification",state:{email:emailVal,status:0}});
    },(error)=>{
      this.setState({btnLoading : false})
      message.error("من فضلك ادخل بريد إلكتروني صحيح")
    })
  };
  
  render() {
    const { btnLoading } = this.state;
    const { currentLang } = this.props; 
    return ( 
        <div className="auth-wrapper">
          <img src={authBG} className="auth-bg" alt="" />
          <div className="auth-form-content">

              <Link to="/" className="back-btn">
               <FaChevronRight />
              رجوع 
              </Link>
              <Link to="/" className="logo-holder">
                <img src={logo} alt="logo" />
              </Link>
              <p className="form-red-p">
              هل نسيت كلمه المرور
              </p>
              <p className="form-hint-p">
              من فضلك ادخل البريد الالكتروني لارسال رساله تحتوي علي رمز التحقق اولا
              </p>
            <Form
              name="basic" 
              onFinish={this.onFinish}  
            >
              <Form.Item
                label={localization.EmailAddress[currentLang]}
                name="email"
                rules={[
                  { required: true, message: `${localization.pleaseInput[currentLang]} ${localization.EmailAddress[currentLang]}` },
                  {
                    type: 'email',
                    message: `${localization.Emailnotvalid[currentLang]}`, 
                  },
                ]}
                className="input-holder"
              >
                <Input /> 
              </Form.Item> 
                <Button size="large" type="primary" htmlType="submit" block loading={btnLoading}>
                  {localization.Send[currentLang]}
                </Button>
            </Form>
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentLang : state.user.currentLang,
}) 

const LoginWithRouter = withRouter(ForgetPassword);
export default connect(mapStateToProps)(LoginWithRouter);
